import React, { useLayoutEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import styles from '../Dashboards.module.css';
import { useAhaPanelContents, useHtmlSnapshot } from '../hooks';
import Spinner from '../../common/Spinner';
import renderIf from 'render-if';

const RichTextPanel = ({ panel }) => {
  const shouldUseHtmlSnapshot = useHtmlSnapshot();
  const ahaContents = useAhaPanelContents({
    panel,
  });
  const [height, setHeight] = useState(0);
  const panelRef = useRef(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => {
    if (panelRef.current) {
      setHeight(panelRef.current.clientHeight);
    }
  });

  return (
    <>
      {renderIf(ahaContents || shouldUseHtmlSnapshot)(
        <div
          ref={panelRef}
          style={{
            '--rich-text-panel-height': `${height}px`,
          }}
          className={classnames(styles.RichTextPanelContainer, {
            initialized: ahaContents,
          })}
          // contents come from html snapshots on the server
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: shouldUseHtmlSnapshot ? '' : ahaContents,
          }}
        />
      )}
      {renderIf(!ahaContents && !shouldUseHtmlSnapshot)(<Spinner />)}
    </>
  );
};

export default RichTextPanel;
